import { AnswerIconType, QuizAnswer, QuizQuestion } from '@/types/lead-magnet';

/** Keys mirror `diagnostic.question.iconKey` and the files in `dialogs/`. */
const SIGNAL_ICON_KEYS = new Set([
	'compass',
	'clock',
	'search',
	'circle-x',
	'grid',
	'eye',
	'flag',
	'shield',
	'message-square',
	'share'
]);

const normalizeKey = (value: string) => value.trim().toLowerCase();

const LEGACY_SIGNAL_ICONS_BY_SLUG: Record<string, string> = {
	'strategic-foundation': 'compass',
	'last-update': 'clock',
	proof: 'search',
	'heritage-translation': 'circle-x',
	consistency: 'grid',
	'visual-authenticity': 'eye',
	'competitive-position': 'flag',
	'brand-accountability': 'shield',
	'brand-language': 'message-square',
	'the-referral-test': 'share'
};

export const resolveSignalIcon = (question: QuizQuestion): string | null => {
	const key = question.iconKey
		? normalizeKey(question.iconKey)
		: LEGACY_SIGNAL_ICONS_BY_SLUG[normalizeKey(question.slug)];

	return key && SIGNAL_ICON_KEYS.has(key) ? `/assets/images/dialogs/${key}.svg` : null;
};

const DRAWN_ANSWER_ICONS = new Set<AnswerIconType>(['check', 'cross']);

const LEGACY_ANSWER_ICONS_BY_VALUE: Record<string, AnswerIconType> = {
	yes: 'check',
	no: 'cross'
};

export const resolveAnswerIcon = (answer: QuizAnswer): AnswerIconType | null => {
	const type = answer.iconType ?? LEGACY_ANSWER_ICONS_BY_VALUE[normalizeKey(answer.value)];

	return type && DRAWN_ANSWER_ICONS.has(type) ? type : null;
};
